import {useEffect, useState} from 'react'
import RouteContainer from '../../../common/styles/RouteContainer'
import booksitoutIcon from '../../../config/BooksitoutIcon'
import RouteTitle from '../../../common/RouteTitle/RouteTitle'
import {useNavigate} from 'react-router-dom'
import {Form} from 'react-bootstrap'
import NoContentForFullScreen from '../../../common/NoContentForFullScreen'
import LibraryCard from '../find/LibraryCard'
import LibraryCardLoading from '../find/LibraryCardLoading'
import useCurrentLocation from '../useCurrentLocation'
import useLibraryNear from '../useLibraryNear'
import ReloadButton from '../../../common/styles/ReloadButton'
import RowSpacer from '../../../common/styles/RowSpacer'
import RouteTitleConfig from '../../../config/RouteTitleConfig'
import LoadingBar from '../../../common/LoadingBar'
import useHtmlTitle from '../../../common/useHtmlTitle'
import useUrlQuery from "../../../common/hooks/useUrlQuery";

const LibraryNearRoute = () => {
	useHtmlTitle('주변 도서관')

	const range = useUrlQuery('range')
	const [currentRange, setCurrentRange] = useState<number>(5)

    useEffect(() => {
        if (range) {
            setCurrentRange(Number(range))
        }
    }, [range])

	const [lat, long, locationName, isLocationLoading, locationError, refreshLocation] = useCurrentLocation()
	const [libraries, isLibraryLoading] = useLibraryNear(lat, long, currentRange, true)

	return (
		<RouteContainer>
			<RouteTitle
				icon={<booksitoutIcon.location />}
				title={'내 주변 도서관'}
				subTitle={isLocationLoading ? <LoadingBar size={5} /> : locationName}
				currentKey={'library'}
				buttons={RouteTitleConfig.Library}
				rightUi={
					<>
						<DistanceSelect currentRange={currentRange} setCurrentRange={setCurrentRange} />
						<ReloadButton onClick={refreshLocation} top={30} />
					</>
				}
			/>

			<RowSpacer />
			{locationError ? <></> : isLibraryLoading ? Array.from({ length: 6 }).map(_ => <LibraryCardLoading />) : libraries.length === 0 ? <NoContentForFullScreen message={`${currentRange}km 내에 도서관이 없어요`} adjustForSmallScreen={true} /> : libraries.map(library => <LibraryCard library={library} />)}
		</RouteContainer>
	)
}

const DistanceSelect = ({ currentRange, setCurrentRange }) => {
	const navigate = useNavigate()

	return (
		<Form className="pe-md-5 me-md-3">
			<Form.Select
				style={{ backgroundColor: 'var(--card-card-bg-color)', color: 'var(--text-color)' }}
				onChange={e => {
					navigate(`/library/near?range=${e.target.value}`)
					setCurrentRange(Number(e.target.value))
				}}
			>
				{[5, 10, 15, 20].map(r => {
					return (
						<option selected={r === currentRange} value={r}>
							{r}km 근처까지
						</option>
					)
				})}
			</Form.Select>
		</Form>
	)
}

export default LibraryNearRoute
